module.exports = __webpack_public_path__ + "static/estate_cover-a110128d8687f995184482f5f63ded54.png";